exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-4104abc3]{\n  color: #2c3e50;\n  font-size: 30px;\n  font-weight: bold;\n}\nh5[data-v-4104abc3]{\n  padding-left: 25px;\n  border-left: #ccc 5px solid;\n  font-weight: normal;\n  font-size: 20px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n.page-not-found-link[data-v-4104abc3]\n{\n  color: #3eaf7c;\n  font-size: 20px;\n  text-decoration: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4104abc3","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pages/PageNotFound.vue
// module id = 1809
// module chunks = 0